export const industryArray = [
  "aace.com",
  "afassanoco.com",
  "conventusmedia.com",
  "diabetes.org",
  "freemanco.com",
  "medscape.net",
  "diabeteseducator",
  "cardiometabolichealth.org",
];
export const excludedEmails = [
  "aeussen@dexcom.com",
  "benjamin.byrne@dexcom.com",
  "Donald.rentoul@dexcom.com",
  "erik.bjorkman@dexcom.com",
  "heike.recktenwald@dexcom.com",
  "Karen.Baxter@dexcom.com",
  "lars.krinelke@dexcom.com",
  "Paul.Cheverton@Dexcom.com",
];
